var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7,20.8c-1.3,0-2.5-.9-2.7-2.3l-1.6-8.7h-.4c-.4,0-.8-.3-.8-.8s.3-.8.8-.8h3.7l4.8-4.8c.1-.1.3-.2.5-.2s.4,0,.5.2.2.3.2.5,0,.4-.2.5l-3.7,3.7h10.4l-3.7-3.7c-.1-.1-.2-.3-.2-.5s0-.4.2-.5.3-.2.5-.2.4,0,.5.2l4.8,4.8h3.7c.4,0,.8.3.8.8s-.3.8-.8.8h-.4l-1.6,8.7c-.2,1.3-1.4,2.3-2.7,2.3H5.7ZM4.4,18.2c.1.6.6,1,1.2,1h12.7c.6,0,1.1-.4,1.2-1l1.5-8.5H2.9l1.5,8.5ZM16,16.8s0,0-.1,0c-.2,0-.4-.1-.5-.3-.1-.2-.2-.4-.1-.6l.5-3c0-.4.4-.6.7-.6s0,0,.1,0c.2,0,.4.1.5.3.1.2.2.4.1.6l-.5,3c0,.4-.4.6-.7.6ZM8,16.8c-.4,0-.7-.3-.7-.6l-.5-3c0-.2,0-.4.1-.6.1-.2.3-.3.5-.3,0,0,0,0,.1,0,.4,0,.7.3.7.6l.5,3c0,.4-.2.8-.6.9,0,0,0,0-.1,0ZM12,16.8c-.4,0-.8-.3-.8-.8v-3c0-.4.3-.8.8-.8s.8.3.8.8v3c0,.4-.3.8-.8.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.12dbfc60.svg";
export { ForwardRef as ReactComponent };